import { appFormRelayForwardUpdatedRenderStateAction, createRenderSlice, RenderState } from "../lib/relay/AppFormRelay"

const formRenderSlice = createRenderSlice(
	(builder) => {
		// receive forwarded render state updates from the frontend—
		// see comments on createRenderSlice for details
		builder.addCase(appFormRelayForwardUpdatedRenderStateAction, (_state, action): RenderState => {
			// console.log(action.type, action.payload)
			return action.payload
		})
	}
)

export default formRenderSlice.reducer
